module.exports = __webpack_public_path__ + "static/media/foto3.22455429.png";